import { Component, OnInit } from '@angular/core';
import { ProvidehttpService } from '../providehttp.service';
import { Router } from "@angular/router";
import { ProcessShellService } from '../process-shell/services/process-shell.service';
import { ShellService } from '../shell/shell.service';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  state: any;
responsive: any;

  constructor(
    public http : ProvidehttpService,
    private router: Router,
    public _processShellService:ProcessShellService,
    public _shellService: ShellService,
    public _commonService: CommonService
  ) { }

  ngOnInit() {
  }

  gotoDashboard(){
    if(this._processShellService.getApplicationMode()=='RM')  this.router.navigate(["rm-home"]);
    else window.open(window.location.origin + window.location.pathname + '#/launcher?action=application-status',"_self");
  }

}
